import React from 'react'
import { twMerge } from 'tailwind-merge'

interface MobileIconProps {
  className?: string
}

export const MobileIcon = ({ className }: MobileIconProps) => {
  return <i className={twMerge('fas fa-mobile-alt ml-[10px]', className)} />
}
